import isEmpty from 'lodash/isEmpty'
import { UserAnalytics } from '@cfc/analytics'
import { fetchUserAccess } from 'auth/stores/access/operations'
import { fetchUserProfile } from 'auth/stores/profile/operations'
import { fetchUserContext } from 'auth/stores/userContext/operations'
import SecondStepApi from 'lib/api/secondStepApi'
import { setCookie } from 'utils/cookiesHelper'
import { adaptContextV4ToLegacyContext } from 'lib/api/adapters/context'
import { getQueryParams } from 'utils/routing/urlHelpers'
import { FlagsSingleton } from 'flags'

// ============= AUTH UPDATES ================
export const handleAuthUpdate = ({
  auth0,
  dispatch,
  launchDarklyReady,
  profile,
}) => {
  if (!auth0.isLoading && !auth0.isAuthenticated && !auth0.error) {
    const pathname =
      window.location.pathname + window.location.search + window.location.hash
    const loginOptions = getQueryParams(window.location.href)
    setCookie('pathname', pathname)
    auth0.loginWithRedirect(loginOptions)
  } else if (auth0.isAuthenticated) {
    // TODO: move access call back up to this spot after removal of v3 flag
    // and remove appended v4 path once the base api address is updated to v4
    if (profile === undefined) {
      fetchUserProfile(dispatch, `${SecondStepApi.baseApiAddress}v4/`)
    }
    // Wait for LaunchDarkly user context to settle before first getUserContext
    if (launchDarklyReady) {
      // Drive AUTH to correct API: v3 '/context' or v4 '/context/me'
      const apiAddress =
        SecondStepApi.baseApiAddressForContext || SecondStepApi.baseApiAddress
      const contextPath = apiAddress.endsWith('/v4/') ? 'context/me' : 'context'
      fetchUserContext(dispatch, apiAddress, {
        contextPath,
        // Adaptation lives in LEARN for v4
        adaptResponse:
          contextPath === 'context/me'
            ? adaptContextV4ToLegacyContext
            : undefined,
      })
      // In this case, access will be using the same API base as context
      fetchUserAccess(dispatch, apiAddress)
    }
  }
}
// ========== SITES ME ==========
export const handleSitesMeFetch = (auth0, fetchUserSites) => {
  if (auth0.isAuthenticated) {
    fetchUserSites()
  }
}

export const handleUpdateUserContext = async ({
  profile,
  setContextHasBeenCalled,
  setLoadingUserContext,
}) => {
  setContextHasBeenCalled(true)
  const { displayName, email, roles } = profile || {}
  const updatedUserConfigForLaunchDarkly = {
    userEmail: email,
    roles,
    name: displayName,
  }
  setLoadingUserContext(true)
  try {
    await FlagsSingleton.updateUserContext(updatedUserConfigForLaunchDarkly)
  } catch (e) {
    // Failing silently and we just serve a false variation
    console.error(e)
  }
  setLoadingUserContext(false)
}

export const handleUserAnalyticsSetup = (profile, sites) => {
  if (!isEmpty(profile) && sites !== null) {
    const safeSites = Array.isArray(sites)
      ? sites.filter(site => site && site.id != null)
      : []
    try {
      UserAnalytics.initialize({
        email: profile.email,
        userId: profile.id,
        profile,
        sites: safeSites,
      })
    } catch (e) {
      console.error(e)
    }
  }
}
